import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { LikeOutlined, UserOutlined, ShoppingOutlined, TeamOutlined } from '@ant-design/icons';

const Dashboard: React.FC = () => {
  return (
    <div style={{ padding: '0 24px 24px' }}>
      <h2 style={{ marginBottom: 24 }}>📊 仪表盘</h2>

      <Row gutter={16} style={{ marginBottom: '24px' }}>
        <Col span={6}>
          <Card hoverable>
            <Statistic
              title="👤 活跃用户"
              value={128}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card hoverable>
            <Statistic
              title="📋 总订单"
              value={9328}
              prefix={<ShoppingOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card hoverable>
            <Statistic
              title="👍 点赞数"
              value={8745}
              prefix={<LikeOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card hoverable>
            <Statistic
              title="👥 团队成员"
              value={42}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>

      <Card
        title="📈 系统概览"
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <p>欢迎使用 FunHua Admin 后台管理系统！</p>
      </Card>
    </div>
  );
};

export default Dashboard;